'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeSections = require('@shopify/theme-sections');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Menu Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Menu
 * 
 * @namespace menu
 */

var config = {
  mobileMenu: '#MobileMenu',
  hamburger: '#Hamburger',
  body: 'body'
};

// Toggle visibility of mobile menu with hamburger is clicked
(0, _jquery2.default)(config.hamburger).on('click', toggleMenu);
(0, _jquery2.default)(config.mobileMenu).find('a').on('click', hideMenu);
console.log('menu.js');
function toggleMenu() {
  (0, _jquery2.default)(config.body).toggleClass('mobile-menu-visible');
}

function hideMenu(evt) {
  evt.stopPropagation();
  console.log((0, _jquery2.default)('body').hasClass('template-index'));
  if ((0, _jquery2.default)(this).attr('href').indexOf('#') > 0 && (0, _jquery2.default)('body').hasClass('template-homepage')) {
    console.log('remove class');
    (0, _jquery2.default)(config.body).removeClass('mobile-menu-visible');
  }
}

(0, _themeSections.register)('menu', {
  onLoad: function onLoad() {}
});